import { useMemo, useState } from 'react';
import { Alert, Typography } from 'antd';
import { useTalentPoolLabels } from '../contexts/TalentPoolLabelsContext';
import { useBatches } from '../hooks/useBatches';
import { adminAlertStyle, adminPageWrap } from '../styles/adminPageShell';
import {
  EvalRelationsEditModals,
  type CreateTarget,
  type EditTarget,
} from './eval-relations/EvalRelationsEditModals';
import { EvalRelationsTable } from './eval-relations/EvalRelationsTable';

export function EvalRelationsPage() {
  const { batches, batchId, setBatchId } = useBatches();
  const { evaluateeDisplayOrder } = useTalentPoolLabels();
  const poolOrder = useMemo(
    () => evaluateeDisplayOrder.filter((pool) => pool !== 'MARKETING_ACQUISITION'),
    [evaluateeDisplayOrder],
  );
  const [editTarget, setEditTarget] = useState<EditTarget | null>(null);
  const [createTarget, setCreateTarget] = useState<CreateTarget | null>(null);

  return (
    <div style={adminPageWrap}>
      <div className="tg-page-title">评价关系一览</div>
      <Typography.Paragraph type="secondary" style={{ marginBottom: 16, maxWidth: 960 }}>
        按被评价人透视全员评价链；支持完成情况筛选（与「岗位胜任力 · 派单」一致）、行内编辑改派、异常标红与导出 CSV。
      </Typography.Paragraph>
      <Alert
        type="info"
        showIcon
        style={adminAlertStyle}
        message="按「被评价人」视角看评价关系（可编辑、可补派、缺失高亮、异常提示、可导出）"
        description={
          <>
            一行 = 一个被评价人。<strong style={{ color: '#fa541c' }}>红色「缺失·补派」按钮</strong>表示该列至今未派评价人，点一下就能补派（按被评价人池自动匹配模板）。
            点行末「编辑」进入行内编辑模式后，已有的评价人 cell 也可点击改派；改完点「完成」退出。
            「直属领导」列与花名册 directLeader 不一致会标红，可填备注、可一键确认。
            右上「行筛选」可切到「只看缺失 / 只看异常」批量定位需要处理的行。
          </>
        }
      />
      <EvalRelationsTable
        batches={batches}
        batchId={batchId}
        setBatchId={setBatchId}
        poolOrder={poolOrder}
        onEdit={setEditTarget}
        onCreate={setCreateTarget}
      />
      <EvalRelationsEditModals
        batchId={batchId}
        editTarget={editTarget}
        createTarget={createTarget}
        onCloseEdit={() => setEditTarget(null)}
        onCloseCreate={() => setCreateTarget(null)}
      />
    </div>
  );
}
